import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CreditRequestComponent } from './credit-request.component';
import * as fromComponents from './components';

const routes: Routes = [
  {
    path: '',
    component: CreditRequestComponent,
    children: [
      {
        path: '',
        component: fromComponents.CreditRequestListComponent,
        data: {
          title: 'Solicitudes de credito',
          id: 'CreditRequestModule_creditRequestTracker',
        },
      },
      {
        path: 'create',
        component: fromComponents.CreateCreditRequestComponent,
        data: {
          title: 'Crear solicitud de crédito',
          id: 'CreateCreditRequestComponent_createcreditrequest',
        },
        children: [
          {
            path: 'creditAnalysisLegalEntity',
            component: fromComponents.LegalEntityCreditPlanStepperComponent,
            data: {
              title: 'Analisis de crédito (PAC)',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'thirtyDaysLegalEntity',
            component: fromComponents.LegalEntityThirtyDaysPlanStepperComponent,
            data: {
              title: '30 Días',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'legalEntityPlan',
            component: fromComponents.LegalEntityCreditPlanStepperComponent,
            data: {
              title: 'Juridico',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'franchisedEntityPlan',
            component: fromComponents.FranchisedCreditPlanStepperComponent,
            data: {
              title: 'Juridico',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'agreementLegalEntity',
            component: fromComponents.LegalEntityCreditPlanStepperComponent,
            data: {
              title: 'Convenio',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'creditAnalysisPerson',
            component: fromComponents.PersonCreditAnalysisPlanStepperComponent,
            data: {
              title: 'Analisis de crédito (PAC)',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'immediateProcedurePerson',
            component:
              fromComponents.PersonImmediateProcedurePlanStepperComponent,
            data: {
              title: 'Trámite Inmediato',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'fastTrackPerson',
            component: fromComponents.PersonFastTrackPlanStepperComponent,
            data: {
              title: 'Fast Track',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'guaranteedPerson',
            component: fromComponents.PersonGuaranteedPlanStepperComponent,
            data: {
              title: 'Plan Garantizado',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'normalPerson',
            component: fromComponents.PersonNormalPlanStepperComponent,
            data: {
              title: 'Normal',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'agreementPerson',
            component: fromComponents.PersonAgreementPlanStepperComponent,
            data: {
              title: 'Convenio',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'employeePerson',
            component: fromComponents.PersonEmployeePlanStepperComponent,
            data: {
              title: 'Empleado',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'nbaPlan',
            component: fromComponents.PersonNormalPlanStepperComponent,
            data: {
              title: 'Plan Impulsa',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
        ],
      },
      {
        path: 'modify/:creditRequestNumber',
        component: fromComponents.ModifyCreditRequestComponent,
        data: {
          title: 'Modificar Solicitud de Crédito en Borradores',
          id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
        },
        children: [
          {
            path: 'creditAnalisisLegalEntity',
            component: fromComponents.LegalEntityCreditPlanStepperComponent,
            data: {
              title: 'Analisis de crédito (PAC)',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'legalEntityPlan',
            component: fromComponents.LegalEntityCreditPlanStepperComponent,
            data: {
              title: 'Juridico',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'franchisedEntityPlan',
            component: fromComponents.FranchisedCreditPlanStepperComponent,
            data: {
              title: 'Juridico',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'thirtyDaysLegalEntity',
            component: fromComponents.LegalEntityThirtyDaysPlanStepperComponent,
            data: {
              title: '30 Días',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'agreementLegalEntity',
            component: fromComponents.LegalEntityCreditPlanStepperComponent,
            data: {
              title: 'Convenio',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'creditAnalysisPerson',
            component: fromComponents.PersonCreditAnalysisPlanStepperComponent,
            data: {
              title: 'Analisis de crédito (PAC)',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'immediateProcedurePerson',
            component:
              fromComponents.PersonImmediateProcedurePlanStepperComponent,
            data: {
              title: 'Trámite Inmediato',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'fastTrackPerson',
            component: fromComponents.PersonFastTrackPlanStepperComponent,
            data: {
              title: 'Fast Track',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'guaranteedPerson',
            component: fromComponents.PersonGuaranteedPlanStepperComponent,
            data: {
              title: 'Plan Garantizado',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'normalPerson',
            component: fromComponents.PersonNormalPlanStepperComponent,
            data: {
              title: 'Normal',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'agreementPerson',
            component: fromComponents.PersonAgreementPlanStepperComponent,
            data: {
              title: 'Convenio',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'employeePerson',
            component: fromComponents.PersonEmployeePlanStepperComponent,
            data: {
              title: 'Empleado',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
          {
            path: 'nbaPlan',
            component: fromComponents.PersonNormalPlanStepperComponent,
            data: {
              title: 'Plan Impulsa',
              id: 'CreateCreditRequestComponent_createcreditrequest_creditRequestNumber',
            },
          },
        ],
      },
      {
        path: ':creditRequestNumber',
        component: fromComponents.CreditRequestDetailComponent,
        data: {
          title: 'Detalle de solicitud de credito',
          id: 'CreditRequestDetailComponent_creditrequestdetail',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreditRequestRoutingModule { }
